const _ = [
  [/^#!.*\bpython[23]?\b/, "python"],
  [/^#!.*\bnode\b/, "javascript"],
  [/^#!.*\bdeno\b/, "typescript"],
  [/^#!.*\bbun\b/, "typescript"],
  [/^#!.*\bruby\b/, "ruby"],
  [/^#!.*\bperl\b/, "perl"],
  [/^#!.*\bphp\b/, "php"],
  [/^#!.*\bbash\b/, "bash"],
  [/^#!.*\bzsh\b/, "zsh"],
  [/^#!.*\bsh\b/, "bash"],
  [/^#!.*\blua\b/, "lua"],
  [/^#!.*\bawk\b/, "awk"]
], $ = [
  // Rust - distinctive keywords
  [/\b(fn|impl|trait|pub\s+fn|let\s+mut|&mut|->)\b/, "rust"],
  // Go - distinctive keywords
  [/\b(func|package\s+\w+|import\s+\(|go\s+func|chan\s+\w+)\b/, "go"],
  // Python - distinctive patterns
  [/\b(def\s+\w+\s*\(|import\s+\w+|from\s+\w+\s+import|class\s+\w+:)\b/, "python"],
  // TypeScript - distinctive type annotations
  [/:\s*(string|number|boolean|void)\b|\binterface\s+\w+\s*\{/, "typescript"],
  // JavaScript - distinctive patterns (after TS check)
  [/\b(const|let|var)\s+\w+\s*=|function\s+\w+\s*\(|=>\s*\{/, "javascript"],
  // Ruby - distinctive keywords
  [/\b(def\s+\w+|end\b|do\s*\|.*\||puts\s+|require\s+['"])\b/, "ruby"],
  // Java - distinctive patterns
  [/\b(public\s+class|private\s+\w+|System\.out\.println)\b/, "java"],
  // C++ - distinctive patterns
  [/\b(#include\s*<|std::|template\s*<|nullptr|cout\s*<<)\b/, "cpp"],
  // C - distinctive patterns (after C++ check)
  [/\b(#include\s*[<"]|printf\s*\(|int\s+main\s*\(|void\s+\w+\s*\()\b/, "c"],
  // C# - distinctive patterns
  [/\b(namespace\s+\w+|using\s+System|public\s+static\s+void)\b/, "c-sharp"],
  // PHP - distinctive patterns
  [/<\?php|\$\w+\s*=/, "php"],
  // Swift - distinctive patterns
  [/\b(func\s+\w+|var\s+\w+:\s*\w+|let\s+\w+:\s*\w+|@objc)\b/, "swift"],
  // Kotlin - distinctive patterns
  [/\b(fun\s+\w+|val\s+\w+|var\s+\w+:|data\s+class)\b/, "kotlin"],
  // Scala - distinctive patterns
  [/\b(def\s+\w+|val\s+\w+|var\s+\w+|object\s+\w+|case\s+class)\b/, "scala"],
  // Haskell - distinctive patterns
  [/\b(module\s+\w+|import\s+qualified|data\s+\w+\s*=|::\s*\w+\s*->)\b/, "haskell"],
  // Elixir - distinctive patterns
  [/\b(defmodule\s+\w+|def\s+\w+|defp\s+\w+|\|>)\b/, "elixir"],
  // Lua - distinctive patterns
  [/\b(local\s+\w+\s*=|function\s+\w+\.\w+|require\s*\()\b/, "lua"],
  // SQL - distinctive patterns
  [/\b(SELECT\s+.*\s+FROM|INSERT\s+INTO|CREATE\s+TABLE|ALTER\s+TABLE)\b/i, "sql"],
  // Shell/Bash - distinctive patterns
  [/\b(if\s+\[\s*|then\b|fi\b|echo\s+["']|export\s+\w+=)\b/, "bash"],
  // YAML - distinctive patterns
  [/^\s*[\w-]+:\s*[\w\-"'[{]|^---\s*$/, "yaml"],
  // JSON - distinctive patterns
  [/^\s*\{[\s\S]*"[\w-]+":\s*/, "json"],
  // TOML - distinctive patterns
  [/^\s*\[[\w.-]+\]\s*$|^\s*\w+\s*=\s*["'\d\[]/, "toml"],
  // HTML - distinctive patterns
  [/<(!DOCTYPE|html|head|body|div|span|p|a\s)/i, "html"],
  // CSS - distinctive patterns
  [/^\s*[\w.#@][\w\s,#.:>+~-]*\{[^}]*\}|@media\s|@import\s/, "css"],
  // Markdown - distinctive patterns
  [/^#{1,6}\s+\w|^\s*[-*+]\s+\w|^\s*\d+\.\s+\w|```\w*\n/, "markdown"],
  // XML - distinctive patterns
  [/<\?xml|<[\w:-]+\s+xmlns/, "xml"],
  // Dockerfile
  [/^FROM\s+\w+|^RUN\s+|^COPY\s+|^ENTRYPOINT\s+/m, "dockerfile"],
  // Nginx config
  [/\b(server\s*\{|location\s+[\/~]|proxy_pass\s+)\b/, "nginx"],
  // Zig
  [/\b(pub\s+fn|const\s+\w+\s*=|@import\(|comptime)\b/, "zig"]
];
function M(e) {
  const t = e.split(`
`)[0];
  for (const [r, s] of _)
    if (r.test(t))
      return s;
  for (const [r, s] of $)
    if (r.test(e))
      return s;
  return null;
}
function R(e) {
  const t = e.match(/\blanguage-(\w+)\b/);
  if (t) return t[1];
  const r = e.match(/\blang-(\w+)\b/);
  if (r) return r[1];
  const s = /* @__PURE__ */ new Set([
    "rust",
    "javascript",
    "typescript",
    "python",
    "ruby",
    "go",
    "java",
    "c",
    "cpp",
    "csharp",
    "php",
    "swift",
    "kotlin",
    "scala",
    "haskell",
    "elixir",
    "lua",
    "sql",
    "bash",
    "shell",
    "yaml",
    "json",
    "toml",
    "html",
    "css",
    "xml",
    "markdown",
    "dockerfile",
    "nginx",
    "zig",
    "text",
    "plaintext",
    "console",
    "sh"
  ]);
  for (const a of e.split(/\s+/))
    if (s.has(a.toLowerCase()))
      return a.toLowerCase();
  return null;
}
function F(e) {
  const t = {
    js: "javascript",
    ts: "typescript",
    py: "python",
    rb: "ruby",
    rs: "rust",
    sh: "bash",
    shell: "bash",
    yml: "yaml",
    cs: "c-sharp",
    csharp: "c-sharp",
    "c++": "cpp",
    "c#": "c-sharp",
    "f#": "fsharp",
    dockerfile: "dockerfile",
    docker: "dockerfile",
    makefile: "make",
    plaintext: "text",
    plain: "text",
    txt: "text"
  }, r = e.toLowerCase();
  return t[r] || r;
}
const L = "2.16.0", U = [
  "ada",
  "agda",
  "asciidoc",
  "asm",
  "awk",
  "bash",
  "batch",
  "c",
  "c-sharp",
  "caddy",
  "capnp",
  "cedar",
  "cedarschema",
  "clojure",
  "cmake",
  "cobol",
  "commonlisp",
  "cpp",
  "css",
  "d",
  "dart",
  "devicetree",
  "diff",
  "dockerfile",
  "dot",
  "elisp",
  "elixir",
  "elm",
  "erlang",
  "fish",
  "fsharp",
  "gleam",
  "glsl",
  "go",
  "graphql",
  "groovy",
  "haskell",
  "hcl",
  "hlsl",
  "html",
  "idris",
  "ini",
  "java",
  "javascript",
  "jinja2",
  "jq",
  "json",
  "julia",
  "kotlin",
  "lean",
  "lua",
  "markdown",
  "matlab",
  "meson",
  "nginx",
  "ninja",
  "nix",
  "objc",
  "ocaml",
  "perl",
  "php",
  "postscript",
  "powershell",
  "prolog",
  "python",
  "query",
  "r",
  "rego",
  "rescript",
  "ron",
  "ruby",
  "rust",
  "scala",
  "scheme",
  "scss",
  "solidity",
  "sparql",
  "sql",
  "ssh-config",
  "starlark",
  "styx",
  "svelte",
  "swift",
  "textproto",
  "thrift",
  "tlaplus",
  "toml",
  "tsx",
  "typescript",
  "typst",
  "uiua",
  "vb",
  "verilog",
  "vhdl",
  "vim",
  "vue",
  "wit",
  "x86asm",
  "xml",
  "yaml",
  "yuri",
  "zig",
  "zsh"
], J = [
  {
    name: "attribute",
    tag: "at"
  },
  {
    name: "constant",
    tag: "co"
  },
  {
    name: "constant.builtin",
    tag: "cb",
    parentTag: "constant"
  },
  {
    name: "constructor",
    tag: "cr"
  },
  {
    name: "function.builtin",
    tag: "fb",
    parentTag: "function"
  },
  {
    name: "function",
    tag: "f"
  },
  {
    name: "function.method",
    tag: "fm",
    parentTag: "function"
  },
  {
    name: "keyword",
    tag: "k"
  },
  {
    name: "keyword.conditional",
    tag: "kc",
    parentTag: "keyword"
  },
  {
    name: "keyword.coroutine",
    tag: "ko",
    parentTag: "keyword"
  },
  {
    name: "keyword.debug",
    tag: "kd",
    parentTag: "keyword"
  },
  {
    name: "keyword.exception",
    tag: "ke",
    parentTag: "keyword"
  },
  {
    name: "keyword.function",
    tag: "kf",
    parentTag: "keyword"
  },
  {
    name: "keyword.import",
    tag: "ki",
    parentTag: "keyword"
  },
  {
    name: "keyword.operator",
    tag: "kp",
    parentTag: "keyword"
  },
  {
    name: "keyword.repeat",
    tag: "kr",
    parentTag: "keyword"
  },
  {
    name: "keyword.return",
    tag: "kt",
    parentTag: "keyword"
  },
  {
    name: "keyword.type",
    tag: "ky",
    parentTag: "keyword"
  },
  {
    name: "operator",
    tag: "o"
  },
  {
    name: "property",
    tag: "pr"
  },
  {
    name: "punctuation",
    tag: "p"
  },
  {
    name: "punctuation.bracket",
    tag: "pb",
    parentTag: "punctuation"
  },
  {
    name: "punctuation.delimiter",
    tag: "pd",
    parentTag: "punctuation"
  },
  {
    name: "punctuation.special",
    tag: "ps",
    parentTag: "punctuation"
  },
  {
    name: "string",
    tag: "s"
  },
  {
    name: "string.special",
    tag: "ss",
    parentTag: "string"
  },
  {
    name: "tag",
    tag: "tg"
  },
  {
    name: "tag.delimiter",
    tag: "td",
    parentTag: "tag"
  },
  {
    name: "tag.error",
    tag: "te",
    parentTag: "tag"
  },
  {
    name: "type",
    tag: "t"
  },
  {
    name: "type.builtin",
    tag: "tb",
    parentTag: "type"
  },
  {
    name: "type.qualifier",
    tag: "tq",
    parentTag: "type"
  },
  {
    name: "variable",
    tag: "v"
  },
  {
    name: "variable.builtin",
    tag: "vb",
    parentTag: "variable"
  },
  {
    name: "variable.parameter",
    tag: "vp",
    parentTag: "variable"
  },
  {
    name: "comment",
    tag: "c"
  },
  {
    name: "comment.documentation",
    tag: "cd",
    parentTag: "comment"
  },
  {
    name: "macro",
    tag: "m"
  },
  {
    name: "label",
    tag: "l"
  },
  {
    name: "diff.addition",
    tag: "da"
  },
  {
    name: "diff.deletion",
    tag: "dd"
  },
  {
    name: "number",
    tag: "n"
  },
  {
    name: "text.literal",
    tag: "tl"
  },
  {
    name: "text.emphasis",
    tag: "em"
  },
  {
    name: "text.strong",
    tag: "st"
  },
  {
    name: "text.uri",
    tag: "tu"
  },
  {
    name: "text.reference",
    tag: "tr"
  },
  {
    name: "string.escape",
    tag: "se",
    parentTag: "string"
  },
  {
    name: "text.title",
    tag: "tt"
  },
  {
    name: "text.strikethrough",
    tag: "tx"
  },
  {
    name: "spell",
    tag: "sp"
  },
  {
    name: "embedded",
    tag: "eb"
  },
  {
    name: "error",
    tag: "er"
  },
  {
    name: "namespace",
    tag: "ns"
  },
  {
    name: "include",
    tag: "in",
    parentTag: "keyword"
  },
  {
    name: "storageclass",
    tag: "sc",
    parentTag: "keyword"
  },
  {
    name: "repeat",
    tag: "rp",
    parentTag: "keyword"
  },
  {
    name: "conditional",
    tag: "cn",
    parentTag: "keyword"
  },
  {
    name: "exception",
    tag: "ex",
    parentTag: "keyword"
  },
  {
    name: "preproc",
    tag: "pp",
    parentTag: "keyword"
  },
  {
    name: "none",
    tag: ""
  },
  {
    name: "character",
    tag: "ch",
    parentTag: "string"
  },
  {
    name: "character.special",
    tag: "cs",
    parentTag: "string"
  },
  {
    name: "variable.member",
    tag: "vm",
    parentTag: "variable"
  },
  {
    name: "function.definition",
    tag: "fd",
    parentTag: "function"
  },
  {
    name: "type.definition",
    tag: "tf",
    parentTag: "type"
  },
  {
    name: "function.call",
    tag: "fc",
    parentTag: "function"
  },
  {
    name: "keyword.modifier",
    tag: "km",
    parentTag: "keyword"
  },
  {
    name: "keyword.directive",
    tag: "dr",
    parentTag: "keyword"
  },
  {
    name: "string.regexp",
    tag: "rx",
    parentTag: "string"
  },
  {
    name: "nospell",
    tag: ""
  },
  {
    name: "float",
    tag: "n"
  },
  {
    name: "boolean",
    tag: "cb"
  }
];
function P(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
const j = {
  manual: !1,
  theme: "one-dark",
  selector: "pre code",
  cdn: "jsdelivr",
  version: L,
  // Precise version from manifest
  pluginsUrl: "",
  // Empty means use bundled manifest
  hostUrl: "",
  // Empty means use CDN based on version
  logger: console,
  resolveHostJs: ({ baseUrl: e, path: t }) => import(
    /* @vite-ignore */
    `${e}/${t}`
  ),
  resolveHostWasm: ({ baseUrl: e, path: t }) => fetch(`${e}/${t}`),
  resolveJs: ({ baseUrl: e, path: t }) => import(
    /* @vite-ignore */
    `${e}/${t}`
  ),
  resolveWasm: ({ baseUrl: e, path: t }) => fetch(`${e}/${t}`)
};
let m = null, d = null, f = { ...j };
const h = /* @__PURE__ */ new Map(), k = /* @__PURE__ */ new Map(), p = new Set(U);
let c = null, b = null;
async function T(e) {
  if (e.pluginsUrl)
    return b || (b = (async () => {
      e.logger.debug(`[arborium] Loading local plugins manifest from: ${e.pluginsUrl}`);
      const t = await fetch(e.pluginsUrl);
      if (!t.ok)
        throw new Error(`Failed to load plugins.json: ${t.status}`);
      c = await t.json(), e.logger.debug(`[arborium] Loaded local manifest with ${c?.entries.length} entries`);
    })(), b);
}
function E(e, t) {
  if (c) {
    const n = c.entries.find((l) => l.language === e);
    if (n)
      return n.local_js.substring(0, n.local_js.lastIndexOf("/"));
  }
  const r = t.cdn, s = t.version;
  let a;
  return r === "jsdelivr" ? a = "https://cdn.jsdelivr.net/npm" : r === "unpkg" ? a = "https://unpkg.com" : a = r, `${a}/@arborium/${e}@${s}`;
}
async function x(e, t) {
  const r = h.get(e);
  if (r)
    return t.logger.debug(`[arborium] Grammar '${e}' found in cache`), r;
  const s = k.get(e);
  if (s)
    return t.logger.debug(`[arborium] Grammar '${e}' already loading, waiting...`), s;
  const a = H(e, t);
  k.set(e, a);
  try {
    return await a;
  } finally {
    k.delete(e);
  }
}
async function H(e, t) {
  if (await T(t), !p.has(e) && !c?.entries.some((r) => r.language === e))
    return t.logger.debug(`[arborium] Grammar '${e}' not available`), null;
  try {
    const r = E(e, t), s = t.resolveJs === j.resolveJs ? ` from ${r}/grammar.js` : "";
    t.logger.debug(`[arborium] Loading grammar '${e}'${s}`);
    const a = await t.resolveJs({
      language: e,
      baseUrl: r,
      path: "grammar.js"
    }), n = await t.resolveWasm({ language: e, baseUrl: r, path: "grammar_bg.wasm" });
    await a.default({ module_or_path: n });
    const l = a.language_id();
    l !== e && t.logger.warn(`[arborium] Language ID mismatch: expected '${e}', got '${l}'`);
    const w = a.injection_languages(), y = {
      languageId: e,
      injectionLanguages: w,
      module: a,
      // UTF-8 parsing for Rust host
      parseUtf8: (g) => {
        const i = a.create_session();
        try {
          a.set_text(i, g);
          const o = a.parse(i);
          return {
            spans: o.spans || [],
            injections: o.injections || []
          };
        } catch (o) {
          return t.logger.error("[arborium] Parse error:", o), { spans: [], injections: [] };
        } finally {
          a.free_session(i);
        }
      },
      // UTF-16 parsing for JavaScript public API
      parseUtf16: (g) => {
        const i = a.create_session();
        try {
          a.set_text(i, g);
          const o = a.parse_utf16(i);
          return {
            spans: o.spans || [],
            injections: o.injections || []
          };
        } catch (o) {
          return t.logger.error("[arborium] Parse error:", o), { spans: [], injections: [] };
        } finally {
          a.free_session(i);
        }
      }
    };
    return h.set(e, y), t.logger.debug(`[arborium] Grammar '${e}' loaded successfully`), y;
  } catch (r) {
    return t.logger.error(`[arborium] Failed to load grammar '${e}':`, r), null;
  }
}
const v = /* @__PURE__ */ new Map();
let I = 1;
function q(e) {
  globalThis.arboriumHost = {
    /** Check if a language is available (sync) */
    isLanguageAvailable(t) {
      return p.has(t) || h.has(t);
    },
    /** Load a grammar and return a handle (async) */
    async loadGrammar(t) {
      const r = await x(t, e);
      if (!r) return 0;
      for (const [a, n] of v)
        if (n === r) return a;
      const s = I++;
      return v.set(s, r), s;
    },
    /** Parse text using a grammar handle (sync) - returns UTF-8 offsets for Rust host */
    parse(t, r) {
      const s = v.get(t);
      return s ? s.parseUtf8(r) : { spans: [], injections: [] };
    }
  };
}
function C(e) {
  if (e.hostUrl)
    return e.hostUrl;
  const t = e.cdn, r = e.version;
  let s;
  t === "jsdelivr" ? s = "https://cdn.jsdelivr.net/npm" : t === "unpkg" ? s = "https://unpkg.com" : s = t;
  const a = r === "latest" ? "" : `@${r}`;
  return `${s}/@arborium/arborium${a}/dist`;
}
async function G(e) {
  return m || d || (d = (async () => {
    q(e);
    const t = C(e), r = e.resolveHostJs === j.resolveHostJs ? ` from ${t}/arborium_host.js` : "";
    e.logger.debug(`[arborium] Loading host${r}`);
    try {
      const s = await e.resolveHostJs({ baseUrl: t, path: "arborium_host.js" }), a = await e.resolveHostWasm({ baseUrl: t, path: "arborium_host_bg.wasm" });
      return await s.default({ module_or_path: a }), m = {
        highlight: s.highlight,
        isLanguageAvailable: s.isLanguageAvailable
      }, e.logger.debug("[arborium] Host loaded successfully"), m;
    } catch (s) {
      return e.logger.error("[arborium] Failed to load host:", s), null;
    }
  })(), d);
}
async function S(e, t, r) {
  const s = u(r), a = await G(s);
  if (a)
    try {
      return a.highlight(e, t);
    } catch (n) {
      s.logger.error("[arborium] Host highlight failed:", n);
    }
  return P(t);
}
async function A(e, t) {
  const r = u(t), s = await x(e, r);
  if (!s) return null;
  const { module: a } = s;
  return {
    languageId: () => s.languageId,
    injectionLanguages: () => s.injectionLanguages,
    highlight: async (n) => S(e, n, t),
    // Public API returns UTF-16 offsets for JavaScript compatibility
    parse: (n) => s.parseUtf16(n),
    createSession: () => {
      const n = a.create_session();
      return {
        setText: (l) => a.set_text(n, l),
        // Session.parse() returns UTF-16 offsets for JavaScript compatibility
        parse: () => {
          try {
            const l = a.parse_utf16(n);
            return {
              spans: l.spans || [],
              injections: l.injections || []
            };
          } catch (l) {
            return r.logger.error("[arborium] Session parse error:", l), { spans: [], injections: [] };
          }
        },
        cancel: () => a.cancel(n),
        free: () => a.free_session(n)
      };
    },
    dispose: () => {
    }
  };
}
async function z(e, t, r) {
  const s = u(r), a = e;
  await a.default({ module_or_path: t });
  const n = a.language_id(), l = a.injection_languages(), w = {
    languageId: n,
    injectionLanguages: l,
    module: a,
    parseUtf8: (g) => {
      const i = a.create_session();
      try {
        a.set_text(i, g);
        const o = a.parse(i);
        return {
          spans: o.spans || [],
          injections: o.injections || []
        };
      } catch (o) {
        return s.logger.error("[arborium] Parse error:", o), { spans: [], injections: [] };
      } finally {
        a.free_session(i);
      }
    },
    parseUtf16: (g) => {
      const i = a.create_session();
      try {
        a.set_text(i, g);
        const o = a.parse_utf16(i);
        return {
          spans: o.spans || [],
          injections: o.injections || []
        };
      } catch (o) {
        return s.logger.error("[arborium] Parse error:", o), { spans: [], injections: [] };
      } finally {
        a.free_session(i);
      }
    }
  };
  return h.set(n, w), p.add(n), s.logger.debug(`[arborium] Grammar '${n}' registered`), await A(n, r);
}
function u(e) {
  return e ? { ...f, ...e } : { ...f };
}
function N(e) {
  f = { ...f, ...e };
}
async function O(e, t) {
  const r = u(t);
  return await T(r), p.has(e) || (c?.entries.some((s) => s.language === e) ?? !1);
}
async function W(e) {
  const t = u(e);
  return await T(t), c ? c.entries.map((r) => r.language) : Array.from(p);
}
export {
  U as availableLanguages,
  M as detectLanguage,
  R as extractLanguageFromClass,
  W as getAvailableLanguages,
  u as getConfig,
  S as highlight,
  J as highlights,
  O as isLanguageAvailable,
  A as loadGrammar,
  F as normalizeLanguage,
  L as pluginVersion,
  z as registerGrammar,
  N as setConfig
};
//# sourceMappingURL=arborium.js.map
